export const loadBalance = () => ({
  type: 'LOAD_BALANCE',
  payload: {
    client: 'cloudloyalty',
    request: {
      url: '/v1/participants/me/simpleBalance'
    }
  }
})

export default { loadBalance }



// WEBPACK FOOTER //
// ./src/features/Balance/actions.js